module.exports = "/_next/static/images/c0b5da5cd66c768598e3524a36eea25c-savingsPlant.svg";